import { Aktenzeichen } from './aktenzeichen.model';
import { AktenzeichenRenderer } from './aktenzeichen-renderer';
import { AktenzeichenUtil } from './aktenzeichen-util.service';

export class LongAktenzeichenRenderer extends AktenzeichenRenderer {
	render(aktenzeichen: Aktenzeichen | string): string {
		if (typeof aktenzeichen === 'string') {
			aktenzeichen = AktenzeichenUtil.parse(aktenzeichen);
		}

		const amtsgerichtsNummer = aktenzeichen.amtsgerichtsNummer;
		const register = AktenzeichenUtil.getRegister(aktenzeichen);
		const blattNummer = AktenzeichenUtil.getBlattNummer(aktenzeichen);

		return amtsgerichtsNummer + ' ' + register + ' ' + blattNummer;
	}
}
